import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const salesMaterialStatistics = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '销售',
            dataIndex: '销售',
            key: '销售',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo['销售'] || [],
        },
        {
            title: '销售经理',
            dataIndex: '销售经理',
            key: '销售经理',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo['销售经理'] || [],
        },
        {
            title: '物料信息',
            key: 'material',
            scopedSlots: {
                customRender: 'material',
            }
        }
    ]
}
